// src/redux/certitemplateSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_certitemplate,
  add_certitemplate,
  update_certitemplate,
  delete_certitemplate,
  get_certitemplate_list,
  get_studentreport_genrate,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  certitemplate: [],
  certitemplatelist:[],
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    report_key:"",
    title:"",
    filters:"",
    fields:"",
  },
};


// Async Thunks for API Calls
export const fetchcertitemplatelist = createAsyncThunk(
    'certitemplate/fetchcertitemplatelist',
    async ({school_id,report_type,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_certitemplate_list(school_id,report_type,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  // Async Thunks for API Calls


// Async Thunks for API Calls
export const fetchcertitemplate = createAsyncThunk(
  "certitemplate/fetchcertitemplate",
  async ({ page, page_size,school_id,report_key, token, signal }, { rejectWithValue }) => {

    try {
      const response = await get_certitemplate(page, page_size,school_id,report_key,token, signal);

        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const createcertitemplate = createAsyncThunk(
  "certitemplate/createcertitemplate",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_certitemplate(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatecertitemplate = createAsyncThunk(
  "certitemplate/updatecertitemplate",
  async ({ data, token, school_id,signal }, { rejectWithValue }) => {
    try {
      const response = await update_certitemplate(data, token,school_id, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletecertitemplate = createAsyncThunk(
  "certitemplate/deletecertitemplate",
  async ({ ids, token,school_id, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_certitemplate({ ids }, token,school_id, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// certitemplate Slice
const certitemplateSlice = createSlice({
  name: 'certitemplates',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
 
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      const { id, title,bank_name,account_no,ifsc,balance} = action.payload;
      state.formData = { id, title,bank_name,account_no,ifsc,balance};
    },
    resetFormData(state) {
    state.formData = {
    title:"",
    bank_name:"",
    account_no:"",
    ifsc:"",
    balance:0,
      };
    },
    setcertitemplate(state, action) {
      state.certitemplate = action.payload;
    },
   
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
   
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchcertitemplatelist.fulfilled, (state, action) => {
        state.certitemplatelist = action.payload;
      })
      .addCase(fetchcertitemplatelist.rejected, (state, action) => {
        state.certitemplatelist = [];
      })
       // Fetch certitemplate
       .addCase(fetchcertitemplate.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchcertitemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.certitemplate = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchcertitemplate.rejected, (state, action) => {
        state.loading = false;
        state.certitemplate = [];
        state.error = action.payload;
      })

      // Add certitemplate
      .addCase(createcertitemplate.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createcertitemplate.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createcertitemplate.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update certitemplate
      .addCase(updatecertitemplate.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatecertitemplate.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatecertitemplate.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete certitemplate
      .addCase(deletecertitemplate.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletecertitemplate.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletecertitemplate.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {  
  setcertitemplate,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setPageSize } = certitemplateSlice.actions;
export default certitemplateSlice.reducer;
